import CompanyProfileCreateComponent from "../components/CompanyProfileCreate";
import useCompanyProfileCreate from "../hooks/useCompanyProfileCreate";

const CompanyProfileCreate = (props) => {
  const companyProfileCreateProps = useCompanyProfileCreate(props);
  return <CompanyProfileCreateComponent {...companyProfileCreateProps} />;
};

export default CompanyProfileCreate;
